export default __webpack_public_path__ + "static/media/digitizePoint.f8ed6685.cur";